import { Component } from "react"

import * as utils from "../../utils/utils"
import { CLOUDPAYMENTS_PUBLIC_ID } from "../../utils/env-management"
import { UserAccount } from "../../utils/UserAccount"
import { logEvent } from "../../utils/helpers"
import { CURRENCY } from "../../utils/constants"
import { httpClient } from "../../utils/infrastructure/httpClient"

const USER_CLOSE_WIDGET_REASON = "User has cancelled"

class CloudPaymentsWidget extends Component {
    constructor(props) {
        super(props)

        this.widgetScript && this.widgetScript.remove()

        this.widgetScript = utils.loadScript(
            "https://widget.cloudpayments.ru/bundles/cloudpayments",
            this.onScriptLoaded,
            () => this.props.onError("Ошибка при соединении с сервисом оплаты")
        )
    }

    componentWillUnmount() {
        this.widgetScript && this.widgetScript.remove()
    }

    render() {
        return ""
    }

    onScriptLoaded = () => {
        void httpClient
            .post(`payment/order/${this.props.order_hash}/init`, {
                payment_system: this.props.payment_system,
            })
            .then()

        this.props.onWidgetShown()
        this.widget = new window.cp.CloudPayments()
        const psyHashId = this.props.psy ? this.props.psy.hash_id : undefined

        this.widget.charge(
            {
                publicId: CLOUDPAYMENTS_PUBLIC_ID,
                description: this.props.service_description,
                amount: Number(this.props.price),
                currency: CURRENCY.RUB,
                invoiceId: this.props.order_hash,
                skin: "mini",
                data: {
                    clientName: UserAccount.name,
                    clientEmail: UserAccount.email,
                    psyHashId: psyHashId,
                },
            },
            () => {
                logEvent({
                    event: "after_payment",
                    data: { psychologist_hash_id: psyHashId },
                })
                this.props.onSuccess()
            },
            (reason, options) => {
                logEvent({
                    event: "payment_failed",
                    data: { reason, options },
                })
                if (reason !== USER_CLOSE_WIDGET_REASON) {
                    this.props.onFail?.(reason)
                } else {
                    this.props.onClose?.()
                }
            }
        )
    }
}

export { CloudPaymentsWidget }
